import { getSelectedModel } from "../../../../hooks/use-selected-model"
import { fusion } from "./ingeteamev/fusion"
import { rapid60 } from "./ingeteamev/rapid60"
import { rapid420 } from "./ingeteamev/rapid420"
import { rapid120180 } from "./ingeteamev/rapid120180"

export const ingeteamev = newValues => {
  const model = getSelectedModel()

  const modelsMap = {
    rapid60: rapid60,
    rapid120180: rapid120180,
    rapid420: rapid420,
    fusion: fusion,
  }

  newValues = modelsMap[model](newValues)
  return newValues
}
